import { style } from "@angular/animations";
import { QueryRequestModel } from "src/app/core/models/QueryRequestModel";

export class TableColumns {
    public static readonly NON_PARTNER_TABLE_COLUMNS = [
      {
        title: 'Action',
        compare: null,
        priority: false,
        showShort: false,
        sortDirections:[]
      },
      {
        title: 'Reference Number',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.QueryRequestNumber || '').localeCompare(b.QueryRequestNumber || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Subject',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Subject || '').localeCompare(b.Subject || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Request Status',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.PartnerQueryStatus || '').localeCompare(b.PartnerQueryStatus || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Requestor Name',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.RequestorName || '').localeCompare(b.RequestorName || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Requested Date',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => {
          const dateA = a.RequestedDate ? new Date(a.RequestedDate).getTime() : 0;
          const dateB = b.RequestedDate ? new Date(b.RequestedDate).getTime() : 0;
          return dateA - dateB;
        },
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      }
      ,
      {
        title: 'Category',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => a.Category.localeCompare(b.Category || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Sub Category',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => a.SubCategory.localeCompare(b.SubCategory || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Block',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Block || '').localeCompare(b.Block || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },    
      {
        title: 'Priority',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.PriorityLevel || '').localeCompare(b.PriorityLevel || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Confidential',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Confidential || '').localeCompare(b.Confidential || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Department',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Department || '').localeCompare(b.Department || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Sub Deptartment',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.SubDeptartment || '').localeCompare(b.SubDeptartment || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Request Completion Date',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => {
          const dateA = a.RequestedDate ? new Date(a.RequestedDate).getTime() : 0;
          const dateB = b.RequestedDate ? new Date(b.RequestedDate).getTime() : 0;
          return dateA - dateB;
        },
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Request Created By',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.CreatedByUserName || '').localeCompare(b.CreatedByUserName || ''),
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Due Date',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => {
          const dateA = a.RequestedDate ? new Date(a.RequestedDate).getTime() : 0;
          const dateB = b.RequestedDate ? new Date(b.RequestedDate).getTime() : 0;
          return dateA - dateB;
        },
        priority: false,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      }
    ];

    public static readonly PARTNER_TABLE_COLUMNS = [
      {
        title: 'Action',
        compare: null,
        priority: false,
        showShort: false,
        sortDirections:[],
        style: 'padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;'
      },
      {
        title: 'Reference Number',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.QueryRequestNumber || '').localeCompare(b.QueryRequestNumber || ''),
        priority: 3,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
        style: 'padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;'
      },
      {
        title: 'Subject',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Subject || '').localeCompare(b.Subject || ''),
        priority: 2,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
        style: 'padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;'
      },
      {
        title: 'Request Status',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.PartnerQueryStatus || '').localeCompare(b.PartnerQueryStatus || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Requestor Name',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.RequestorName || '').localeCompare(b.RequestorName || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      }
      ,
      {
        title: 'Company',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => a.CompanyName.localeCompare(b.CompanyName || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Block',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Block || '').localeCompare(b.Block || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Requested Date',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => {
          const dateA = a.RequestedDate ? new Date(a.RequestedDate).getTime() : 0;
          const dateB = b.RequestedDate ? new Date(b.RequestedDate).getTime() : 0;
          return dateA - dateB;
        },
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Priority',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.PriorityLevel || '').localeCompare(b.PriorityLevel || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Confidential',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Confidential || '').localeCompare(b.Confidential || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Department',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.Department || '').localeCompare(b.Department || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Sub Deptartment',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.SubDeptartment || '').localeCompare(b.SubDeptartment || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Request Completion Date',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => {
          const dateA = a.RequestedDate ? new Date(a.RequestedDate).getTime() : 0;
          const dateB = b.RequestedDate ? new Date(b.RequestedDate).getTime() : 0;
          return dateA - dateB;
        },
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      },
      {
        title: 'Request Created By',
        compare: (a: QueryRequestModel, b: QueryRequestModel) => (a.CreatedByUserName || '').localeCompare(b.CreatedByUserName || ''),
        priority: 1,
        showShort: true,
        sortDirections: ['ascend', 'descend', null],
      }
    ];
    public static getFilteredColumns(originalArray: any[], excludeTitles: string[]): any[] {
      return originalArray.filter(column => !excludeTitles.includes(column.title));
    }
}